import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class UuidService {
  private readonly UUID_KEY = 'MBC_uuid';

  constructor() { }

  getUuid(): string {
    let uuid = localStorage.getItem(this.UUID_KEY);
    if (!uuid) {
      uuid = uuidv4();
      localStorage.setItem(this.UUID_KEY, uuid);
    }
    return uuid;
  }
}
